import { render, staticRenderFns } from "./BidPopup.vue?vue&type=template&id=5a513376&scoped=true&"
import script from "./BidPopup.vue?vue&type=script&lang=js&"
export * from "./BidPopup.vue?vue&type=script&lang=js&"
import style0 from "./BidPopup.vue?vue&type=style&index=0&id=5a513376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a513376",
  null
  
)

export default component.exports